var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pay-situation-detail-container" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "mobile-card",
          { attrs: { "show-footer": true } },
          [
            _c("template", { slot: "title" }, [_vm._v(_vm._s(_vm.title))]),
            _c("template", { slot: "content" }, [
              _vm.$utils.isNotEmpty(_vm.detail.needAllMoney) ||
              _vm.$utils.isNotEmpty(_vm.detail.needMoney)
                ? _c("div", [
                    _vm.$utils.isNotEmpty(_vm.detail.needMoney)
                      ? _c("div", { staticClass: "flex-form-info" }, [
                          _c("span", [_vm._v("应交")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatMoney")(_vm.detail.needMoney)
                              )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm.$utils.isNotEmpty(_vm.detail.disCountMoney)
                      ? _c("div", { staticClass: "flex-form-info" }, [
                          _c("span", [_vm._v("减免")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatMoney")(_vm.detail.disCountMoney)
                              )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm.$utils.isNotEmpty(_vm.detail.delayMoney)
                      ? _c("div", { staticClass: "flex-form-info" }, [
                          _c("span", [_vm._v("缓交")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.detail.delayExpire + "到期"))
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("formatMoney")(_vm.item.delayMoney))
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm.$utils.isNotEmpty(_vm.detail.reditVos)
                      ? _c(
                          "div",
                          _vm._l(_vm.detail.laterVos, function(item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "flex-form-info" },
                              [
                                _c("span", [_vm._v("贷款")]),
                                _c("span", [_vm._v(_vm._s(item.typeName))]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm._f("formatMoney")(item.money))
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _c("div", {
                      staticClass: "mobile-card-line van-hairline--top"
                    }),
                    _c("div", { staticClass: "flex-form-sum sum-text" }, [
                      _c("span", [_vm._v("当前应交合计")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("formatMoney")(_vm.detail.needAllMoney))
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _c("div", [
                _vm.$utils.isNotEmpty(_vm.detail.payRecordVOS)
                  ? _c(
                      "div",
                      _vm._l(_vm.detail.payRecordVOS, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "flex-form-info" },
                          [
                            _c("span", [_vm._v(_vm._s(item.payTypeName))]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.getPayTicketText(item)))
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("formatMoney")(item.payMoney))
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.$utils.isNotEmpty(_vm.detail.deductionVos)
                  ? _c(
                      "div",
                      _vm._l(_vm.detail.deductionVos, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "flex-form-info" },
                          [
                            _c("span", [_vm._v("抵扣")]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.getDeductionText(item)))
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm._f("formatMoney")(item.money)))
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _c("div", {
                  staticClass: "mobile-card-line van-hairline--top"
                }),
                _c("div", { staticClass: "flex-form-sum sum-text" }, [
                  _c("span", [_vm._v("已交合计")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm._f("formatMoney")(_vm.detail.alreadymoney))
                    )
                  ])
                ])
              ])
            ]),
            _vm.nowMoneyShowed
              ? _c("template", { slot: "footer" }, [
                  _c("div", { staticClass: "flex-form-sum sum-text" }, [
                    _c("span", [_vm._v("当前需交")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("formatMoney")(_vm.detail.nowMoney)))
                    ])
                  ])
                ])
              : _vm._e()
          ],
          2
        )
      ],
      1
    ),
    _c("div", { staticClass: "footer" }, [
      _c(
        "div",
        { staticClass: "footer-bar" },
        [
          _c(
            "mobile-button",
            { attrs: { color: "#005423" }, on: { click: _vm.onBack } },
            [_vm._v("返回上一级")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }